// data-store-checkboxes is used to submit a form with a set of checked
// values that come from outside the form. The form gathers the checked
// values and submits them as a hidden fields array conforming to Rails.
//
// <form data-store-checkboxes="[data-checkbox]
//       data-checkbox-input-name="foo">
// </form>
//
// Now some checkboxes...
// <input data-checkbox checked="checked" id="draft_1" name="ids[]" type="checkbox" value="1" />
// <input data-checkbox checked="checked" id="draft_2" name="ids[]" type="checkbox" value="2" />
//
// When the form is submitted, each checked checkbox will be turned into a rails
// friendly array-named input field. So the form will look like this:
//
// <form data-store-checkboxes="[data-checkbox]" data-checkbox-input-name="foo">
//    <input name='foo[]' value='1' type='hidden'/>
//    <input name='foo[]' value='2' type='hidden'/>
// </form>
//
var Reverb = window.Reverb || {};

Reverb.StoreCheckboxes = (function () {
  function init() {
    bindCheckboxes();

    $(document).on('submit', '[data-store-checkboxes]', function () {
      $(this).trigger('reverb.storeCheckboxes');
    });
  }

  function storeCheckboxes($form) {
    var checkboxes = $($form.data('store-checkboxes'));
    var hiddenInputName = $form.data('checkbox-input-name');

    checkboxes.filter(':checked').each(function () {
      var checkbox = $(this);

      $('<input>').
        attr('type', 'hidden').
        attr('name', hiddenInputName + '[]').
        attr('value', checkbox.val()).
        appendTo($form);
    });
  }

  function bindCheckboxes() {
    $(document).on('reverb.storeCheckboxes', '[data-store-checkboxes]', function () {
      storeCheckboxes($(this));
    });
  }

  return {
    init: init
  };
})();

Reverb.StoreCheckboxes.init();



// WEBPACK FOOTER //
// ./javascripts/components/legacy/dom/store-checkbox.js